import {
    transformAppInit, getConfigGatewayUrl
} from '../app';
import {
    FETCH_REQUEST, FetchRequestAction, nullResponse
} from '../middleware';
import { ActionWithoutPayload } from '../types/common.types';

export const SESSION_START = 'SESSION_START';

export const SESSION_CLEAR = 'SESSION_CLEAR';

export type SessionClearAction = ActionWithoutPayload<typeof SESSION_CLEAR>;

export const SESSION_IDLE_TIMED_OUT = 'SESSION_IDLE_TIMED_OUT';

export const SESSION_EXPIRED = 'SESSION_EXPIRED';

export const SESSION_EXTENDED = 'SESSION_EXTENDED';

export const SESSION_LOGOUT = 'SESSION_LOGOUT';

export type SessionLogoutAction = ActionWithoutPayload<typeof SESSION_LOGOUT>;

export const FETCH_SESSION_NAME = 'session';

export const fetchGetExtendSessionRequest = (): FetchRequestAction<null> => {
    return {
        type: FETCH_REQUEST,
        payload: {
            name: FETCH_SESSION_NAME,
            resolveUrl: getConfigGatewayUrl({
                key: 'UserPortalGateway',
                basePath: '/api/v1/authentication/extendSession'
            }),
            transformInit: transformAppInit,
            transformResponse: nullResponse,
            body: null,
            method: 'GET'
        }
    };
};

export const FETCH_SIGN_OUT_NAME = 'signOut';

export const fetchGetSignOutRequest = (): FetchRequestAction<null> => {
    return {
        type: FETCH_REQUEST,
        payload: {
            name: FETCH_SIGN_OUT_NAME,
            resolveUrl: getConfigGatewayUrl({
                key: 'UserPortalGateway',
                basePath: '/api/v1/authentication/signOut'
            }),
            transformInit: transformAppInit,
            transformResponse: nullResponse,
            body: null,
            method: 'GET'
        }
    };
};

export const sessionClear = (): SessionClearAction => {
    return { type: SESSION_CLEAR };
};

export const sessionStart = (): ActionWithoutPayload<typeof SESSION_START> => {
    return { type: SESSION_START };
};

export const sessionExpired = (): ActionWithoutPayload<typeof SESSION_EXPIRED> => {
    return { type: SESSION_EXPIRED };
};

export const sessionIdleTimedOut = (): ActionWithoutPayload<typeof SESSION_IDLE_TIMED_OUT> => {
    return { type: SESSION_IDLE_TIMED_OUT };
};

export const sessionLogout = (): ActionWithoutPayload<typeof SESSION_LOGOUT> => {
    return { type: SESSION_LOGOUT };
};

export const sessionExtended = (): ActionWithoutPayload<typeof SESSION_EXTENDED> => {
    return { type: SESSION_EXTENDED };
};
